export const PoemLies = () => {
    return (
        <div id="026" className="">
            <p>you learn to bend the truth one millimeter at a time,</p>
            <br />
            <p>[sans serif landscape],</p>
            <p>the sky in hell is as blue as it is on earth,</p>
            <p>[soft surrender],</p>
            <p>it happens outside but it starts in your head,</p>
            <p>[closed circuit],</p>
            <p>when the words ring hollow, you know it,</p>
            <p>[ghost world]</p>
            <p>when you wrap it up to make it look like truth,</p>
            <p>[coarse spiral]</p>
            <p>glass houses inside glass houses,</p>
            <p>a million little holes in which to escape.</p>
            <p>trust me</p>
            <p>all i want to do right now is to distract myself,</p>
            <p>[thought bubbles],</p>
            <p>how many ways to reject this world?</p>
            <p>[self-checkout]</p>
            <p>at least eight billion,</p>
            <p>how easy is it to know that you're doing something wrong</p>
            <p>and then keep doing it?</p>
            <p>[self-inflict?]</p>
            <p>part-truths always woven with part-fiction,</p>
            <p>how easy is it to get used to anything?</p>
            <p>[self-something]</p>
            <p>a planet that keeps trying TO PUT YOU ON THE SPOT,</p>
            <p>when questions feel like fish hooks,</p>
            <p>there is no easier thing to say than "i don't know",</p>
            <p>if they'll find poison in my belly,</p>
            <p>then it must have been the sweetest thing i ever tasted.</p>
            <br />
            <p>does it ever feel like you're finally far enough from it?</p>
            <p>the thing that chases you day in and day out,</p>
            <p>
                when is it a good time to measure? what if the feeling never
                goes away?
            </p>
            <p>the clouds drift on and witness,</p>
            <p>there's a 'me' in this house, another one of 'me' outside</p>
            <p>and the distance between them increases.</p>
        </div>
    );
};
